import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageFootballSeasonService } from "../../../../../commons";
import { PaginatedEnsueCollection } from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { ManageFootballReferee } from "../../../../../commons/models/football/admin/manage-football-referee";

export interface IManageRefereesOption {
  seasonId: number;
  urlParams?: {
    hostTeamId?: number;
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

export interface IFootballManageRefereesState {
  manageSeasonReferees: PaginatedEnsueCollection<ManageFootballReferee>;
  manageSeasonRefereesStatus: StatusEnum;
}

const initialState: IFootballManageRefereesState = {
  manageSeasonReferees: new PaginatedEnsueCollection<ManageFootballReferee>(),
  manageSeasonRefereesStatus: StatusEnum.Idle,
};

export const fetchManageSeasonReferees = createAsyncThunk(
  "manageSeasonReferees/fetchManageSeasonReferees",
  async (options: IManageRefereesOption, thunkAPI) => {
    try {
      const manageSeasonReferees = await manageFootballSeasonService.getSeasonReferees(
        options.seasonId,
        options.urlParams
      );
      return manageSeasonReferees;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageSeasonRefereesSlice = createSlice({
  name: "footballManageSeasonReferees",
  initialState: initialState,
  reducers: {
    cleanUpSeasonReferees(state) {
      state.manageSeasonReferees = new PaginatedEnsueCollection<ManageFootballReferee>();
      state.manageSeasonRefereesStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSeasonReferees.pending, (state) => {
        state.manageSeasonRefereesStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSeasonReferees.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<ManageFootballReferee>>) => {
          state.manageSeasonRefereesStatus = StatusEnum.Succeeded;
          state.manageSeasonReferees = action.payload;
        }
      )
      .addCase(fetchManageSeasonReferees.rejected, (state) => {
        state.manageSeasonRefereesStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSeasonReferees } = footballManageSeasonRefereesSlice.actions;
export default footballManageSeasonRefereesSlice.reducer;
